import { Component } from '@angular/core';
import { TranslateModule } from '@client/app/modules/translate.module';

@Component({
    selector: 'seo-multiple-h1',
    templateUrl: './multiple-h1.component.html',
    standalone: true,
    imports: [TranslateModule],
})
export class SeoMultipleH1Component {
}
